module.exports = __webpack_public_path__ + "files/7a7cacfbea1a6af43ea78fb14f393f5f.png";